import actions from "@iso/redux/user/actions";

const initialState = {
  me: null
};

export default function userReducer(state = initialState, action) {
 switch (action.type) {
   case actions.GET_USER_PROFILE:
     return {
       ...state
     };
   case actions.GET_USER_PROFILE_SUCCESS:
     return {
       ...state,
       me: action.payload
     }
   case actions.GET_USER_PROFILE_ERROR:
     return {
       ...state
     }
   default:
     return state;
 }
}

